import { AutoMap } from "@automapper/classes"

export class FlaconDTO {
    @AutoMap()
    code!: string
    @AutoMap()
    type!: number
    @AutoMap()
    barcode!: string
}